import SquareButton from './SquareButton';
export default SquareButton;
